import React from 'react';
import { useDeviceType } from '@vfit/shared/hooks';
import { CustomText, ImageDivider } from '@vfit/shared/atoms';
import { Fade } from 'react-awesome-reveal';
import { IMoreOfferSelector } from './moreOfferSelector.models';
import MoreOfferMobile from './components/MoreOfferMobile/moreOfferMobile';
import MoreOfferDesktop from './components/MoreOfferDesktop/moreOfferDesktop';
import { DisclaimerContainer } from './moreOfferSelector.style';

const MoreOfferSelector = (props: IMoreOfferSelector) => {
  const { divider, disclaimer } = props;
  const { isMobile } = useDeviceType();
  return (
    <>
      {isMobile ? <MoreOfferMobile {...props} /> : <MoreOfferDesktop {...props} />}
      {disclaimer && (
        <DisclaimerContainer>
          <CustomText text={disclaimer} lineHeight={22} size={16} textAlign="left" />
        </DisclaimerContainer>
      )}
      {divider?.image && (
        <Fade direction="up" triggerOnce>
          <ImageDivider image={divider?.image} alt={divider.text || ''} />
        </Fade>
      )}
    </>
  );
};

export default MoreOfferSelector;
